<template>
    <div class="bottom">
        <div class="footer clearfix">
            <div class="footer_box clearfix">
                <div class="footer_box_left clearfix">
                    <p>南京际华三五二一环保科技有限公司&nbsp;&nbsp;&nbsp; 版权所有&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 邮政编码：211161</p>
                    <p>地址：南京市江宁滨江经济开发区飞鹰路36号&nbsp;&nbsp;&nbsp; 联系电话：025-84939007</p>
                    <div class="footer_box_right footer_box_right1 clearfix">
                        <ul>
                            <li><router-link to="/contactUs">联系方式</router-link></li>
                            <li><router-link to="/productDisplay">网站地图</router-link></li>
                            <li><a href="https://beian.miit.gov.cn" style="color:white;" target="_blank;">苏ICP备2025228310号-1</a></li>
                        </ul>
                    </div>
                </div>

                <div class="footer_box_right clearfix menu-container" style="display: flex; justify-content: space-around; width: 400px; height: 100px; align-items: end;">
                    <div class="menu-item" v-for="(item, index) in menus" :key="index">
                        <div class="menu-title" @click="toggleMenu(index)">
                            {{ item.name }}
                            <span class="arrow" :class="{ up: item.show }">▼</span>
                        </div>
                        <div class="dropdown" v-show="item.show">
                            <a v-for="link in item.links" :key="link.text" :href="link.url" target="_blank">
                                {{ link.text }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'dibu',
    data() {
        return {
            menus: [
                {
                    name: '政府机构网站',
                    show: false,
                    links: [
                        { text: '国务院国资委', url: 'http://www.sasac.gov.cn/' },
                        { text: '国家发改委', url: 'https://www.ndrc.gov.cn/' },
                        { text: '中华人民共和国商务部', url: 'http://www.mofcom.gov.cn/' },
                        { text: '中华人民共和国外交部', url: 'https://www.fmprc.gov.cn/' },
                        { text: '中央文明委', url: 'http://www.wenming.cn/' },
                        { text: '更多政府机构>', url: 'http://www.gov.cn/gjjg/2005-08/01/content_18608.html' },
                        { text: '更多中央机构>', url: 'http://www.qstheory.cn' }
                    ]
                },
                {
                    name: '中央企业网站',
                    show: false,
                    links: [
                        { text: '中国核工业集团公司', url: 'http://www.cnnc.com.cn/' },
                        { text: '中国核工业建设集团公司', url: 'http://www.cnecc.com/' },
                        { text: '中国航天科技集团公司', url: 'http://www.spacechina.com/' },
                        { text: '中国航天科工集团公司', url: 'http://www.casic.com.cn/' },
                        { text: '中国航空工业集团公司', url: 'http://www.avic.com.cn/' },
                        { text: '中国船舶工业集团公司', url: 'http://www.cssc.net.cn/' },
                        { text: '中国船舶重工集团公司', url: 'http://www.csic.com.cn/' }
                       
                    ]
                },
                {
                    name: '新兴际华网站',
                    show: false,
                    links: [
                        { text: '新兴铸管股份有限公司', url: 'http://www.xinxing-pipes.com/' },
                        { text: '新兴发展集团有限公司', url: 'https://www.xxg.com.cn/' },
                        { text: '新兴际华集团', url: 'http://www.xxcig.com/' },
                        { text: '中新联进出口公司', url: 'https://www.cnuiec.com/' }
                       
                    ]
                }
            ]
        }
    },
    methods: {
        toggleMenu(index) {
            this.menus.forEach((menu, i) => {
                menu.show = i === index ? !menu.show : false;
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.bottom{
    width: 100%;
    background-color: rgb(218, 17, 17);
}

.footer {
    margin: 0 auto;
    padding: 20px 50px;
}

.footer_box {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.footer_box_left {
    color: white;
    font-size: 14px;
    line-height: 1.6;
    
    p {
        margin-bottom: 8px;
    }
}

.footer_box_right1 ul {
    list-style: none;
    padding: 0;
    margin: 0;
    
    li {
        display: inline-block;
        margin-right: 20px;
        
        a {
            color: white;
            text-decoration: none;
            font-size: 14px;
            transition: all 0.3s ease;
            
            &:hover {
                color: #ffcccc;
                text-decoration: underline;
            }
        }
    }
}

.menu-container {
    position: relative;
}

.menu-item {
    position: relative;
    margin-bottom: 10px;
    
    .menu-title {
        color: white;
        font-size: 16px;
        font-weight: bold;
        cursor: pointer;
        padding: 5px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        
        &:hover {
            color: #ffcccc;
        }
    }
    
    .arrow {
        font-size: 12px;
        margin-left: 5px;
        transition: transform 0.3s;
        display: inline-block;
        
        &.up {
            transform: rotate(180deg);
        }
    }
    
    .dropdown {
        position: absolute;
        bottom: 100%; // 改为从上方显示
        left: 50%;
        transform: translateX(-50%);
        background: rgb(218, 17, 17);
        border: 1px solid rgba(255, 255, 255, 0.3);
        border-radius: 4px;
        padding: 10px;
        min-width: 200px;
        z-index: 100;
        margin-bottom: 10px; // 添加底部间距
        
        // 添加小三角形指示器
        &::after {
            content: '';
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
            border: 6px solid transparent;
            border-top-color: rgb(218, 17, 17);
        }
        
        a {
            display: block;
            color: white;
            text-decoration: none;
            font-size: 14px;
            padding: 5px 0;
            white-space: nowrap;
            
            &:hover {
                color: #ffcccc;
                padding-left: 5px;
            }
        }
    }
}

// 响应式设计
@media (max-width: 768px) {
    .footer_box {
        flex-direction: column;
    }
    
    .footer_box_left {
        margin-bottom: 20px;
    }
    
    .footer_box_right1 ul li {
        display: block;
        margin-bottom: 10px;
        margin-right: 0;
    }
    
    .menu-container {
        width: 100%;
        justify-content: flex-start;
    }
    
    .menu-item {
        margin-right: 20px;
        margin-bottom: 0;
    }
    
    .dropdown {
        left: 0;
        transform: none;
        
        &::after {
            left: 20px;
            transform: none;
        }
    }
}
// 在原有样式基础上添加以下移动端适配代码

@media (max-width: 768px) {
    .footer {
        padding: 15px 20px;
    }
    
    .footer_box {
        flex-direction: column;
    }
    
    .footer_box_left {
        margin-bottom: 20px;
        
        p {
            font-size: 12px;
            margin-bottom: 5px;
            word-break: break-all;
        }
    }
    
    .footer_box_right1 ul li {
        display: block;
        margin-bottom: 10px;
        margin-right: 0;
    }
    
    .menu-container {
        width: 100%;
        height: auto;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        gap: 10px;
    }
    
    .menu-item {
        flex: 1;
        min-width: 120px;
        margin-right: 0;
        margin-bottom: 10px;
        
        .menu-title {
            font-size: 14px;
            padding: 8px 0;
            white-space: nowrap;
        }
        
        .dropdown {
            position: fixed;
            bottom: auto;
            top: 74%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: rgb(218, 17, 17);
            border: 1px solid rgba(255, 255, 255, 0.3);
            border-radius: 4px;
            padding: 15px;
            min-width: 250px;
            max-width: 90vw;
            z-index: 1000;
            margin-bottom: 0;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
            
            &::after {
                display: none;
            }
            
            a {
                display: block;
                color: white;
                text-decoration: none;
                font-size: 13px;
                padding: 6px 0;
                white-space: normal;
                word-break: break-all;
                
                &:hover {
                    color: #ffcccc;
                    padding-left: 5px;
                }
            }
        }
    }
}

// 小屏手机适配
@media (max-width: 480px) {
    .footer {
        padding: 10px 15px;
    }
    
    .footer_box_left {
        p {
            font-size: 11px;
            line-height: 1.4;
        }
    }
    
    .menu-container {
        // flex-direction: column;
        // gap: 5px;
    }
    
    .menu-item {
        width: 100%;
        min-width: auto;
        
        .menu-title {
            font-size: 13px;
            padding: 10px 0;
        }
        
        .dropdown {
            min-width: 280px;
            max-width: 85vw;
            padding: 12px;
            
            a {
                font-size: 12px;
                padding: 5px 0;
            }
        }
    }
}

// 超小屏适配
@media (max-width: 360px) {
    .footer_box_left p {
        font-size: 10px;
    }
    
    .menu-item .dropdown {
        min-width: 260px;
        max-width: 80vw;
        padding: 10px;
        
        a {
            font-size: 11px;
        }
    }
}
</style>